﻿window.pagerDiagnostics = function () {
    /*
    * Show / Hide Period Selector
    **/
    function setVisibilityPeriodSelector() {
        var timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

        if (timeinterval_value == timeIntervalEnum.AskedPeriod) {
            $("#periodSelector").show();
        } else {
            $("#periodSelector").hide();
        }
    }

    function enableTimeIntervalControls() {
        $("#TimeInterval").data("kendoDropDownList").enable(true);
        $("#TimeInterval").siblings('.k-input-button').removeAttr("disabled");
        $("#From").data("kendoDateTimePicker").enable(true);
        $("#From").siblings('.k-input-button').removeAttr("disabled");
        $("#To").data("kendoDateTimePicker").enable(true);
        $("#To").siblings('.k-input-button').removeAttr("disabled");
        $("#PagerDiagnosticsShowButton").removeAttr("disabled");
    }

    return {
        /**
        * Initialize
        */
        initialize: function (showHistory) {
            $("#PagerDiagnosticsShowButtonLoader").hide();

            if (showHistory) {
                setVisibilityPeriodSelector();
                enableTimeIntervalControls();
                this.showAction(null);
            } else {
                main.setHideDiv("divHardware", false);
                main.setHideDiv("divHistory", false);
            }
        },

        /**
        * onChange for TimeInterval (show / hide periodSelector)
        * @param { any } e
        */
        onChangeTimeInterval: function (e) {
            setVisibilityPeriodSelector();
        },

        /**
        * Action show (will display battery and signal line charts according to the selected period)
        * @param { any } DOMelement
        */
        showAction: function (DOMelement) {
            // Indicator
            $("#PagerDiagnosticsShowButtonLoader").show();

            // get preference / options selected
            var pagerId = parseInt($("#PagerID").val());
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());

            // Get selection period
            var From = moment(timeinterval.GetBeginPeriodSelection(selectedInterval, "From").toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
            var To = moment(timeinterval.GetEndPeriodSelection(selectedInterval, "To").toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");

            // Do request
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("User/ShowPagerDiagnosticsCharts"),
                data: {
                    PagerID: pagerId,
                    From: From,
                    To: To
                },
                success: function (responseData) {
                    // Get response
                    $("#showResult").html(responseData);

                    // Hide Indicator
                    $("#PagerDiagnosticsShowButtonLoader").hide();
                }
            });
        },

        /**
        * start / from 
        * 
        * @param { any } DOMelement
        */
        fromChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var startDate = start.value();
            var endDate = end.value();

            if (startDate) {
                startDate = new Date(startDate);
                startDate.setDate(startDate.getDate());
                end.min(startDate);
            } else if (endDate) {
                start.max(new Date(endDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        /**
        * end / to
        * 
        * @param { any } DOMelement
        */
        toChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var endDate = end.value();
            var startDate = start.value();

            if (endDate) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate());
                start.max(endDate);
            } else if (startDate) {
                end.min(new Date(startDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        }
    }
}();